import { ScrewGroup } from '@scene/objects/screw';
import Scene from '@scene';

export function generateScrewGroup(panel, options, dispatcher) {
  const screwGroup = new ScrewGroup({
    ...options.screw,
    panel: options.panel,
    isSafetyBarrier: true
  });
  screwGroup.position.x = panel.position.x + panel.size.depth / 2;

  screwGroup.onOptionUpdate(dispatcher.bind(this));
  panel.object.addObject(screwGroup);

  // TODO: Remove timeout
  setTimeout(() => {
   const res = panel.isObjectOnPanel(screwGroup.screws);

   Scene.onUpdate(
     {
       screw: {
         outside: {
           state: !!res.length,
           data: res
         }
       }
     },
     true
   );
  });

  return screwGroup;
}



// WEBPACK FOOTER //
// ./src/object-view/generators/safety-barrier/objects/helper.js